import React from "react";
import { ButtonProps } from "../../types/ButtonProps";
import { Button as MButton } from "@mui/material";

const Button = ({
  variant,
  children,
  disabled,
  onClick,
  size,
  color,
  style,
}: ButtonProps) => {
  return (
    //@ts-ignore
    <MButton
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      size={size}
      color={color}
      style={{
        display: "flex",
        width: "100%",
        padding: "1rem 2.5rem",
        justifyContent: "center",
        ...style,
      }}
    >
      {children}
    </MButton>
  );
};

export default Button;
